import moment from "moment";

export function dateStartFormatting(date: Date | null) {
    return moment.utc(date).format("YYYY-MM-DD HH:mm:ss");
}

export function dateEndFormatting(date: Date | null) {
    const endHours = 23;
    const endMinutes = 59;
    const currentDate = moment().format("YYYY-MM-DD");
    const selectedDate = moment(date || new Date()).format("YYYY-MM-DD");
    const setDate = new Date(
        moment(date)
            .hours(endHours)
            .minutes(endMinutes)
            .seconds(endMinutes)
            .format("YYYY-MM-DD HH:mm:ss")
    );
    if (currentDate === selectedDate) {
        return moment.utc().format("YYYY-MM-DD HH:mm:ss");
    } else {
        return moment.utc(setDate).format("YYYY-MM-DD HH:mm:ss");
    }
}
